import * as loanSelector from './loan'
import * as bankReport from './bank-report/bank-report'

const loanSelectors = {
    loanSelector: loanSelector,
    bankReport: bankReport
};

export default loanSelectors;